import { render, staticRenderFns } from "./BusCouponListPage.vue?vue&type=template&id=0bef28a9&scoped=true"
import script from "./BusCouponListPage.vue?vue&type=script&lang=js"
export * from "./BusCouponListPage.vue?vue&type=script&lang=js"
import style0 from "./BusCouponListPage.vue?vue&type=style&index=0&id=0bef28a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef28a9",
  null
  
)

export default component.exports